var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5762 1.48016C17.8414 1.16195 17.7984 0.689026 17.4802 0.423853C17.1619 0.15868 16.689 0.201673 16.4239 0.519881L11.0332 6.98869C9.95034 8.2881 9.18861 9.19936 8.52791 9.79597C7.88262 10.3787 7.43728 10.5639 7.00002 10.5639C6.56276 10.5639 6.11742 10.3787 5.47213 9.79597C4.81143 9.19935 4.04969 8.28809 2.96686 6.98869L1.57618 5.31988C1.31101 5.00167 0.838088 4.95868 0.519881 5.22385C0.201673 5.48903 0.15868 5.96195 0.423853 6.28016L1.85312 7.99528C2.88839 9.23764 3.71748 10.2326 4.46684 10.9092C5.24089 11.6082 6.03216 12.0639 7.00002 12.0639C7.96788 12.0639 8.75914 11.6082 9.5332 10.9092C10.2826 10.2326 11.1116 9.23766 12.1469 7.99532L17.5762 1.48016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.7dbc8398c4e580df0854af7a7017c74d.svg";
export { ForwardRef as ReactComponent };